import { render, staticRenderFns } from "./AddressManage.vue?vue&type=template&id=1d64b193&scoped=true"
import script from "./AddressManage.vue?vue&type=script&lang=js"
export * from "./AddressManage.vue?vue&type=script&lang=js"
import style0 from "./AddressManage.vue?vue&type=style&index=0&id=1d64b193&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d64b193",
  null
  
)

export default component.exports